export class MapSitesLoadGroups {
  static readonly type = '[MapSites] Load Groups';
}

export class MapSitesLoadSites {
  static readonly type = '[MapSites] Load Sites';
}

export class MapSitesRefreshSites {
  static readonly type = '[MapSites] Refresh Site';
}

export class MapSitesDeleteSites {
  static readonly type = '[MapSites] Delete Sites';
}

export class MapSitesDeleteGroups {
  static readonly type = '[MapSites] Delete Groups';
}

export class MapSitesLoadGroupsAndResources {
  static readonly type = '[MapSites] Load Groups and Resources';
}

export class MapSitesLoadDataModel {
  static readonly type = '[MapSites] Load Data Model Site';
}

export class MapSitesDeleteDataModel {
  static readonly type = '[MapSites] Delete Data Model';
}

export class MapSitesClearAll {
  static readonly type = '[MapSites] Clear All';
}
